import RULES from './rules.json'

import type { Rule } from './schema'
import type { RulesObject, RuleNameType, RulesTypes } from './types'

export const convertArrayToObject = (rulesArray: Rule[]): RulesObject => {
  return rulesArray.reduce<RulesObject>((obj, rule) => {
    obj[rule.name as RuleNameType] = rule

    return obj
  }, {} as RulesObject)
}

export function convertToEnum(): RulesTypes {
  const enumObject: { [key: string]: string } = {}

  for (const ruleKey in RULES) {
    if (Object.prototype.hasOwnProperty.call(RULES, ruleKey)) {
      enumObject[ruleKey] = RULES[ruleKey as RuleNameType].name
    }
  }

  return enumObject as RulesTypes
}

export const RULES_LIST_TYPES = convertToEnum()
